export const ContentsData = [
	{ text: '프레쉬 Fresh', value: 1 },
	{ text: '서포머 Sophomore', value: 2 }
];
